import Component from "flarum/Component";
import Button from "flarum/components/Button";
import updateItemData from "../common/util/updateItemData";

export default class DecorationStoreEquipmentListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
  }

  view() {
    const {itemPurchaseData} = this.attrs;
    const moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';
    const itemPurchaseID = itemPurchaseData.id();
    const itemPurchaseDate = itemPurchaseData.assigned_at();
    const itemPurchaseStatus = itemPurchaseData.item_status();
    const itemExpired = itemPurchaseData.is_expired();

    const itemData = itemPurchaseData.decorationData();
    const itemTitle = itemData.item_title();
    const itemType = itemPurchaseData.item_type();
    const itemTypeText = app.translator.trans("ziven-decoration-store.forum.item-purchase-item-type-"+itemType);
    const itemCost = itemData.item_cost();
    const itemCostText = moneyName.replace('[money]', itemCost);
    const itemPurchaseType = itemPurchaseData.purchase_type();
    const itemPurchaseTypeText = app.translator.trans("ziven-decoration-store.lib.item-purchase-type-"+itemPurchaseType);
    const itemProperty = JSON.parse(itemData.item_property());
    const itemPropertyImage = itemProperty.image;

    this.itemPurchaseData = itemPurchaseData;
    this.itemPurchaseID = itemPurchaseID;
    this.itemPropertyImage = itemPropertyImage;
    this.itemType = itemType;

    let itemImageStyle = "";
    if(itemType==="profileBackground"){
      itemImageStyle = "background-image:url("+itemPropertyImage+")";
    }

    let containerClassName = "DecorationEquipmentContainer ";
    containerClassName+=itemPurchaseStatus===0?"DecorationEquipmentUnEquipped":"DecorationEquipmentEquipped";

    return (
      <div className={containerClassName}>
        <div className="DecorationEquipmentItemTitle">
          {itemTitle}
        </div>
        <div className="DecorationEquipmentPropertyImage">
          {itemType==="avatarFrame" && (
            <img className="DecorationEquipmentItemAvatarImage" src={itemPropertyImage} />
          )}
          {itemType==="profileBackground" && (
            <div className="DecorationEquipmentItemProfileBackgroundImage" style={itemImageStyle}></div>
          )}
          {itemType==="usernameColor" && (
            <div className="DecorationEquipmentItemUsernameColorStyle">
              <div className={itemPropertyImage}>{app.translator.trans("ziven-decoration-store.forum.item-property-style-text-effect")}</div>
            </div>
          )}
        </div>

        {itemPurchaseType!=="onetime" && (
          <div style="width: 80px;font-size:10px;font-weight: bold;" className="DecorationEquipmentSubscriptionInfo">
            {itemPurchaseTypeText}
          </div>
        )}

        {itemExpired===1 && (
          <div style="color: red;font-weight: bold;" className="DecorationEquipmentListMiscButtons">
            {app.translator.trans("ziven-decoration-store.forum.item-expired")}
          </div>
        )}

        {itemExpired===0 && (
          <div className="DecorationEquipmentListMiscButtons">
            {itemPurchaseStatus===0 && (
              Button.component({
                  icon: 'fas fa-plus',
                  className: 'Button decorationButton--yellow decorationButton--iconOnly',
                  itemClassName: 'App-primaryControl',
                  onclick: () => {
                    this.setItemStatus(1);
                  },
                }
              )
            )}
            {itemPurchaseStatus===1 && (
              Button.component({
                  style: 'color:white;padding: 2px 8px;',
                  icon: 'fas fa-times',
                  className: 'Button decorationButton--red decorationButton--iconOnly',
                  itemClassName: 'App-primaryControl',
                  onclick: () => {
                    this.setItemStatus(0);
                  },
                }
              )
            )}
          </div>
        )}
      </div>
    );
  }

  setItemStatus(purchaseStatus){
    const purchaseID = this.itemPurchaseID;
    $(".DecorationEquipmentListMiscButtons Button").prop('disabled', true);
    $("#modal .Modal-close Button").prop('disabled', true);

    this.loading = true;
    this.itemPurchaseData
      .save({purchaseID,purchaseStatus})
      .then((purchaseData) => {
        updateItemData(purchaseData);
        this.loading = false;
        $(".DecorationEquipmentListMiscButtons Button").prop('disabled', false);
        $("#modal .Modal-close Button").prop('disabled', false);
      })
      .catch((e) => {
        this.loading = false;
        $(".DecorationEquipmentListMiscButtons Button").prop('disabled', false);
        $("#modal .Modal-close Button").prop('disabled', false);
      });
  }

  precisionRound(number, precision) {
    let factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  }
}
